import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface BooksReadByGenreHistoryResponse {
  books_read_by_genre_history: { student_id: number; fiction: number; nonfiction: number }[]
}

export type BooksReadByGenreHistoryData = BooksReadByGenreHistoryResponse['books_read_by_genre_history'][number]

export async function booksReadByGenreHistory(
  this: StudentEventsService,
  product: LegacyProductRe | LegacyProductRex,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<BooksReadByGenreHistoryData[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('books_read_by_genre_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<BooksReadByGenreHistoryResponse>(url, query)
  if (!data) return null

  if (data.books_read_by_genre_history.length === 0) return null

  return data.books_read_by_genre_history
}
